import { useState } from 'react';
import useApiFetch from '@/hooks/useApiFetch';
import staffMemberServices from '@/services/staffMember';
import { FetchApiIds } from '@/types';
import { PTOStatus } from '@/types/api';
import { StaffMember } from '@/types/api/staffMember';
import EditTimeoffRequestModalComponent, {
  Props as EditTimeoffRequestModalComponentProps,
} from './EditTimeoffRequestModal.component';

type Props = Pick<
  EditTimeoffRequestModalComponentProps,
  | 'isOpen'
  | 'onClose'
  | 'request'
  | 'onUpdateRequest'
  | 'managerId'
  | 'staffMember'
  | 'isLoadingStaffMember'
>;

const EditTimeoffRequestModal = ({
  request,
  staffMember: staffMemberProp,
  isLoadingStaffMember: isLoadingStaffMemberProp,
  ...componentProps
}: Props): JSX.Element => {
  const [status, setStatus] = useState<PTOStatus.APPROVED | PTOStatus.DENIED>(PTOStatus.APPROVED);
  const [isAnswerModalOpen, setIsAnswerModalOpen] = useState<boolean>(false);

  const onOpenPTOAnswerDialog = (answer: PTOStatus.APPROVED | PTOStatus.DENIED): void => {
    setIsAnswerModalOpen(true);
    setStatus(answer);
  };

  const getStaffMemberResponse = useApiFetch<StaffMember>(
    [FetchApiIds.GET_STAFF_MEMBER, request.staffMemberId],
    async () => staffMemberServices.getStaffMember({ staffMemberId: request.staffMemberId }),
    { enabled: staffMemberProp === undefined && isLoadingStaffMemberProp === undefined }
  );

  const staffMember = staffMemberProp ?? getStaffMemberResponse.data;
  const isLoadingStaffMember = isLoadingStaffMemberProp ?? getStaffMemberResponse.isLoading;

  return (
    <EditTimeoffRequestModalComponent
      onOpenPTOAnswerDialog={onOpenPTOAnswerDialog}
      status={status}
      isAnswerModalOpen={isAnswerModalOpen}
      onCloseAnswerModal={() => setIsAnswerModalOpen(false)}
      request={request}
      staffMember={staffMember}
      isLoadingStaffMember={isLoadingStaffMember}
      {...componentProps}
    />
  );
};

export default EditTimeoffRequestModal;
